class ProductPopup {
	constructor(popup) {
		this.popup = popup;
		this.open = false;
		this.slideTime = 500;
		const closeBtn = this.popup.querySelector(".close");
		this.nextBtn = this.popup.querySelector(".slide-btn.next");
		this.prevBtn = this.popup.querySelector(".slide-btn.prev");
		this.quantityInput = this.popup.querySelector(".quantity__input");
		this.quantity_input = this.popup.querySelector("quantity-input")
		this.quantity = this.popup.querySelector(".quantity")
		
		this.slides = this.popup.querySelectorAll(".slide");
		this.currentSlideIndex = 0;
		this.loader = this.popup.querySelector(".loader");

		closeBtn.addEventListener("click", (e) => {
			this.closePopup();
		});
		this.addon_checkbox = this.popup.querySelector("addon-overlay input");

		this.quantityInput.addEventListener("change", (e) => {
			if (((window.customer || {}).tags || "").includes('Appstle_Subscriber')) {
				this.debounce_event(e)
			}
		});
		document.addEventListener("keyup", (e) => {
			if (!this.open) return;
			switch (e.key) {
				case "Escape":
					this.closePopup();
					break;
				case "ArrowLeft":
					this.showPrevSlide();
					break;
				case "ArrowRight":
					this.showNextSlide();
					break;
				default:
					console.log(e.key);
			}
		});
		this.nextBtn.addEventListener("click", (e) => {
			this.showNextSlide();
		});
		this.popup.addEventListener("click", (e) => {
			if (e.target.closest('.popup-content')) return;
			this.closePopup();
		})
		this.prevBtn.addEventListener("click", (e) => {
			this.showPrevSlide();
		});
	}
	debounce_event(e) {
		var x = debounce((e) => {
			this.get_menu_wrapper(e)

		}, 500);
		if (e.target.className === 'quantity__input') {
			x(e)
		}
		
	}
	get_menu_wrapper(e) {
		var menuwrapper = document.querySelector("menu-wrapper");
		if (this.subscription) {
			menuwrapper = document.querySelector("menu-wrapper-subscription");
		}
		menuwrapper.debounceOnChange(e);
	}

	openPopup(productHandle, subscription = false) {
		/* 
			This is used to disable scrolling the body of the page behind the popup
		*/
		document.querySelector("body").classList.add("lock-scroll")
		this.subscription = subscription;
		this.currentSlideIndex = 0;
		this.slides[0].style.display = "flex";
		this.controlSlideBtn(0);
		this.popup.style.display = "grid";
		this.loader.style.display = "grid";
		this.showProduct(productHandle);
		//show the popup on the top - seems hard with css
		const smileUiEl = document.querySelector("#smile-ui-container");
		if (smileUiEl) {
			smileUiEl.style.zIndex = 9999;
		}
	}

	setLockEvent(variant_Id){
		
		const variantId = variant_Id.toString();
		this.quantity.querySelectorAll("button").forEach(b => {
			b.addEventListener('lockQuantity', e => {

				if (e.detail?.variantId === variantId) {
					b.disabled = true
					b.style = "cursor: default;"
				}
			})
			b.addEventListener('unlockQuantity', e => {
			
				
				if (e.detail?.variantId === variantId) {
					b.disabled = false
					b.style = "cursor: initial;"
				}
			})
		})
		const inputNode = this.quantity.querySelector("input")
		inputNode.addEventListener('lockQuantity', e => {
			
				
			if (e.detail?.variantId === variantId) {
				inputNode.disabled = true
				inputNode.style = "cursor: default; background-color: #A3A3A3;"
			}
		})
		inputNode.addEventListener('unlockQuantity', e => {
			if (e.detail?.variantId === variantId) {
				inputNode.disabled = false
				inputNode.style = "cursor: initial; background-color: initial;"
			}
		})
	}

	async showProduct(productHandle) {
		const product = await this.getProduct(productHandle);
		if (product.has_addon && this.popup.querySelector("addon-overlay")) {
			this.popup.querySelector("addon-overlay").style = "display:block";
			this.popup.querySelector("#addon_text").innerHTML = product.addon_text;
			this.popup.querySelector("addon-overlay input").checked = product.addon_checked;
			for (var attr in product.dataset)
				this.popup.querySelector("addon-overlay input").setAttribute(`data-${attr}`, product.dataset[attr]);

		} else if (this.popup.querySelector("addon-overlay")) {
			this.popup.querySelector("addon-overlay").style = "display:none";
		}
		this.open = true;
		this.quantity.id = `QuantityInput-popup-${product.variants[0].id}`;
		this.setLockEvent(product.variants[0].id);
		this.loader.style.display = "none";
		const productTitle = this.popup.querySelector(".product-title");
		const productPrice = this.popup.querySelector(".product-price");
		const productVendor = this.popup.querySelector(".product-vendor");
		const productType = this.popup.querySelector(".product-type");
		const previewImage = this.popup.querySelector("div.preview-image");

		const previewImageMobile = this.popup.querySelector(
			"img.preview-image-mobile"
		);
		const infoImage = this.popup.querySelector(".info-images");
		const productDescription = this.popup.querySelector(".product-description");

		const {
			title,
			price,
			vendor,
			type,
			featured_image,
			description,
			quantity,
			info_images,
			variants,
		} = product;

		productTitle.textContent = title;
		productPrice.textContent = "$" + (price / 100).toFixed(2);
		productVendor.textContent = vendor;
		productType.textContent = type;
		previewImage.innerHTML = `<img src="${product.gif || featured_image}" style="
		width: 100%;
		object-fit: fill;
		height: 100%;
	">`
	
		// previewImage.style.backgroundImage = `url(${product.gif || featured_image})`;
		previewImageMobile.src = featured_image;
		productDescription.innerHTML = description;
		this.quantityInput.value = quantity;
		this.quantityInput.dataset.id = variants[0].id;
		this.quantity_input.dataset.id = variants[0].id;
		this.quantityInput.dataset.price = price;

		infoImage.innerHTML = "";
		info_images.forEach((image) => {
			const img = document.createElement("img");
			img.src = image;
			img.classList.add(`width-${100 / info_images.length}`);
			infoImage.appendChild(img);
		});
	}
	closePopup() {
		/*
			The class "lock-scroll" is used to lock the body from scrolling
			while the pop-up is open. Remove this class when the pop-up closes.
		*/
		const bodyElement = document.querySelector("body")
		if (bodyElement.classList.contains("lock-scroll")) bodyElement.classList.remove("lock-scroll")


		this.popup.style.display = "none";
		if (this.popup.querySelector("addon-overlay")) {
			this.popup.querySelector("addon-overlay").style = "display:none";
		}
		this.open = false;
		this.slides.forEach((slide) => {
			slide.style.display = "none";
		});
	}
	getProduct(productHandle) {
		return fetch(`/products/${productHandle}.js`)
			.then((data) => data.json())
			.then((product) => {
				product.info_images = product.images.filter(
					(img) => img != product.featured_image
				);
				var productQuantity = (
					document.querySelector(`quantity-input input[data-id='${product.variants[0].id}']`) ||
					document.querySelector(`input[data-id='${product.variants[0].id}']`)
				);
				if (productQuantity) {

					product.gif = productQuantity?.dataset?.gif
				}
				productQuantity = productQuantity ? productQuantity.value:0;
				const input = document.querySelector(`addon-overlay input[data-id='${product.variants[0].id}']`)
				const spans = document.querySelector(`addon-overlay #addon-span-${product.variants[0].id}`)
				if (input) {
					product.has_addon = true;
					product.addon_checked = input.checked;
					product.dataset = input.dataset;
					product.gif = input?.dataset?.gif;

				}

				if (spans) {
					product.addon_text = spans.textContent;
					product.addon_
				}
				product.quantity = productQuantity;
				return product;
			});
	}
	showNextSlide() {
		const nextSlideIndex = this.getNextSlideIndex();
		const currentSlide = this.slides[this.currentSlideIndex];
		const nextSlide = this.slides[nextSlideIndex];

		nextSlide.style.display = "flex";
		currentSlide.classList.add("hide-left");
		nextSlide.classList.add("slide-left");
		this.controlSlideBtn(nextSlideIndex);
		setTimeout(() => {
			currentSlide.classList.remove("hide-left");
			nextSlide.classList.remove("slide-left");
			currentSlide.style.display = "none";
			this.currentSlideIndex = nextSlideIndex;
		}, this.slideTime);
	}
	showPrevSlide() {
		const prevSlideIndex = this.getPrevSlideIndex();
		const currentSlide = this.slides[this.currentSlideIndex];
		const prevSlide = this.slides[prevSlideIndex];

		prevSlide.style.display = "flex";
		currentSlide.classList.add("hide-right");
		prevSlide.classList.add("slide-right");
		this.controlSlideBtn(prevSlideIndex);
		setTimeout(() => {
			currentSlide.classList.remove("hide-right");
			prevSlide.classList.remove("slide-right");
			currentSlide.style.display = "none";
			this.currentSlideIndex = prevSlideIndex;
		}, this.slideTime);
	}
	getNextSlideIndex() {
		let nextIndex = this.currentSlideIndex + 1;
		if (nextIndex >= this.slides.length) {
			nextIndex = 0;
		}
		return nextIndex;
	}
	getPrevSlideIndex() {
		let prevIndex = this.currentSlideIndex - 1;
		if (prevIndex < 0) {
			prevIndex = this.slides.length - 1;
		}
		return prevIndex;
	}
	controlSlideBtn(nextCurrentIndex) {
		if (nextCurrentIndex == 0) {
			this.nextBtn.style.display = "grid";
			this.prevBtn.style.display = "none";
		} else if (nextCurrentIndex == this.slides.length - 1) {
			this.nextBtn.style.display = "none";
			this.prevBtn.style.display = "grid";
		} else {
			this.nextBtn.style.display = "grid";
			this.prevBtn.style.display = "grid";
		}
	}
}

const templateProductPopup = document.getElementById("productPopupTemplate");
const productPopupNode = templateProductPopup.content.querySelector(".product-popup");
const productNodePopup = document.body.appendChild(productPopupNode);

const productPopup = new ProductPopup(productNodePopup);